import { QUERY_TYPE_BADGE_CLASS } from "../constants";

const QUERY_TYPE_LABELS = {
  REFUND: "Refund",
  RESCHEDULING: "Rescheduling",
  CANCELLATION: "Cancellation",
  BOOKING_FAILED: "Booking Failed",
};

export default function QueryTypeBadge({ queryType }) {
  const normalized = (queryType || "").toUpperCase().replace(/\s+/g, "_");
  const cls = QUERY_TYPE_BADGE_CLASS[normalized] || "bg-gray-100 text-gray-700";
  const label = QUERY_TYPE_LABELS[normalized] || queryType || "—";
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-semibold ${cls}`}>
      {label}
    </span>
  );
}
